import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
const SortingIcon = ({ size = '24', color = 'currentColor', ascendingColor, descendingColor, isSorted = false, ...attributes }) => {
    return (_jsxs("svg", { width: size, height: size, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...attributes, children: [_jsx("path", { d: "M4.66602 10L7.99935 13.3333L11.3327 10", className: clsx({
                    'stroke-grey-40': isSorted !== 'desc',
                    'stroke-current': isSorted === 'desc',
                }), stroke: descendingColor || color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M4.66602 6.00008L7.99935 2.66675L11.3327 6.00008", stroke: ascendingColor || color, className: clsx({
                    'stroke-grey-40': isSorted !== 'asc',
                    'stroke-current': isSorted === 'asc',
                }), strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
};
export default SortingIcon;
//# sourceMappingURL=index.js.map